import { MILLISECONDS_PER_MINUTE } from 'constants/date';

export const CHECK_TIMESTAMP_INTERVAL = MILLISECONDS_PER_MINUTE / 2;
